import { useAppSelector } from "../../store/hooks";
import { useGetQuery } from "../../store/slices/apiSlice";
import { CementJob } from "../../store/types";

interface CementJobsApiProps {
  wellUid?: string | null;
  wellboreUid?: string | null;
  skip?: boolean;
}

export const useCementJobsAPI = ({
  wellUid,
  wellboreUid,
  skip = false,
}: CementJobsApiProps) => {
  const cementJobsEP = useAppSelector((state) => state.endpoints.cementJobs);
  const wellsEP = useAppSelector((state) => state.endpoints.wells);
  const wellboresEP = useAppSelector((state) => state.endpoints.wellbores);

  const hasBase = Boolean(
    wellsEP && wellUid && wellboresEP && wellboreUid && cementJobsEP
  );
  const url = hasBase
    ? `${wellsEP}/${wellUid}${wellboresEP}/${wellboreUid}${cementJobsEP}`
    : "";

  const {
    data,
    isLoading,
    error,
    refetch,
  } = useGetQuery(url, {
    skip: !hasBase || skip,
    refetchOnMountOrArgChange: true,
  });

  // A wellbore has a single cement-job, so the collection endpoint is queried
  // without a uid and the first (only) element is used.
  const cementJob = Array.isArray(data)
    ? (data[0] as CementJob | undefined)
    : (data as CementJob | undefined);

  return { cementJobsEP, cementJob, isLoading, error, refetch };
};
